@for (hyperflow of hyperflows; track $index) {
    @switch (hyperflow.category) {
        @case ("People") {
            @for (hyper of hyperflow.hyperflows; track $index) {
                <mat-expansion-panel class="hyper-people-expansion">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="d-flex justify-content-start">
                            <div class="hyper-people d-flex justify-content-center align-items-center">
                                <span class="material-symbols-outlined">person</span>
                            </div>
                            <div class="hyper-text">
                                <span class="title">{{hyper.position_holder}}</span>
                                <br>
                                <span class="subtitle">{{hyper.name}}</span>
                                <br>
                                <span class="subtitle">{{hyper.hierarchy}}</span>
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="hyper-text">
                        <span class="subtitle">{{hyper.description}}</span>
                    </div>
                    @if (hyper.hyperflows) {
                        <properties-hyperflows [hyperflows]="[hyper.hyperflows]"></properties-hyperflows>
                    }
                </mat-expansion-panel>
            }
        }
        @case ("Process") {
            @for (hyper of hyperflow.hyperflows; track $index) {
                <mat-expansion-panel class="hyper-people-expansion">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="d-flex justify-content-start">
                            <div class="hyper-people d-flex justify-content-center align-items-center">
                                <span class="material-symbols-outlined">account_tree</span>
                            </div>
                            <div class="hyper-text">
                                <span class="title">{{hyper.name}}</span>
                                <br>
                                <span class="subtitle">{{hyper.hierarchy}}</span>
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    @if (hyper.hyperflows) {
                        <properties-hyperflows [hyperflows]="[hyper.hyperflows]"></properties-hyperflows>
                    }
                </mat-expansion-panel>
            }
        }
        @case ("Technology") {
            @for (hyper of hyperflow.hyperflows; track $index) {
                <mat-expansion-panel class="hyper-people-expansion">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="d-flex justify-content-start">
                            <div class="hyper-people d-flex justify-content-center align-items-center">
                                <span class="material-symbols-outlined">memory</span>
                            </div>
                            <div class="hyper-text">
                                <span class="title">{{hyper.name}}</span>
                                <br>
                                <span class="subtitle">{{hyper.hierarchy}}</span>
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    @if (hyper.hyperflows) {
                        <properties-hyperflows [hyperflows]="[hyper.hyperflows]"></properties-hyperflows>
                    }
                </mat-expansion-panel>
            }
        }
        @case ("Industry Library") {
            @for (hyper of hyperflow.hyperflows; track $index) {
                <mat-expansion-panel class="hyper-people-expansion">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="d-flex justify-content-start">
                            <div class="hyper-people d-flex justify-content-center align-items-center">
                                <span class="material-symbols-outlined">library_books</span>
                            </div>
                            <div class="hyper-text">
                                <span class="title">{{hyper.description}}</span>
                                <br>
                                <span class="subtitle">{{hyper.hierarchy}}</span>
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="hyper-text">
                        <span class="subtitle">{{hyper.name}}</span>
                    </div>
                    @if (hyper.hyperflows) {
                        <properties-hyperflows [hyperflows]="[hyper.hyperflows]"></properties-hyperflows>
                    }
                </mat-expansion-panel>
            }
        }
    }
}
